import { createContext } from "react";

export const ConstantContext = createContext({} as any);
export const UserContext = createContext({} as any);
